import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { Accordion } from '../ui/Accordion';
export function FAQ() {
  const faqs = [{
    question: '¿Tengo que hacer ayunos largos?',
    answer: 'No, el protocolo de 16 horas incluye tus horas de sueño, es muy fácil de seguir y no requiere pasar hambre.'
  }, {
    question: '¿Necesito comprar equipo raro?',
    answer: 'Nada, solo alimentos comunes que encuentras en cualquier supermercado y quizás un suplemento de magnesio económico.'
  }, {
    question: '¿Funciona si ya tomo medicación?',
    answer: 'Este método es nutricional y de hábitos, por lo que complementa otros tratamientos, pero siempre recomendamos consultarlo con tu médico.'
  }, {
    question: '¿Cuándo recibo el material?',
    answer: 'Inmediatamente después de tu compra. Recibirás un correo electrónico con acceso instantáneo a todo el material digital.'
  }];
  return <section className="py-20 md:py-32 px-4 bg-brand-beige" data-id="element-24">
      <div className="max-w-4xl mx-auto" data-id="element-25">
        <FadeIn data-id="element-26">
          <div className="text-center mb-12" data-id="element-27">
            <h2 className="text-3xl md:text-4xl font-bold text-brand-dark mb-4" data-id="element-28">
              Preguntas Frecuentes
            </h2>
            <p className="text-lg text-brand-dark/70" data-id="element-29">
              Resolvemos tus dudas antes de empezar.
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-30">
          <Accordion items={faqs} data-id="element-31" />
        </FadeIn>
      </div>
    </section>;
}